const stickySummary = () => {
  const $sticky_summary = $('[data-cart-summary="desktop"] [data-sticky-summary]');

  if ($sticky_summary.length === 0) {
    return;
  }

  if (window.theme.breakpoints.current === 'mobile' || window.theme.breakpoints.current === 'tablet') {
    $sticky_summary.css('top', 0);
    return;
  }

  const page_scrolltop = $(window).scrollTop();
  const $header = $('.shopify-section.header');
  const $footer = $('footer.shopify-section-group-footer-group');
  let sticky_summary_top = 0;
  const top_padding = Number(($sticky_summary.parent().css('padding-top')).replace('px', ''));

  sticky_summary_top = (page_scrolltop <= $header.outerHeight() + top_padding) ? top_padding : (top_padding + page_scrolltop) - $header.outerHeight();

  // Prevent summary to go under footer
  const max_top = $footer.position().top - $sticky_summary.outerHeight() - (top_padding * 2) - $header.outerHeight() - 50;
  if (sticky_summary_top >= max_top) {
    sticky_summary_top = max_top;
  }

  $sticky_summary.css('top', `${sticky_summary_top}px`);
};

export default () => {
  stickySummary();

  $(window).on('scroll', _.debounce(() => {
    stickySummary();
  }, 10));

  $(window).on('load', () => {
    stickySummary();
  });
};
